
import {Component, Vue} from "vue-property-decorator";
import FilesQualite from "@/components/qualite/FilesQualite.vue";
import SidebarQualite from "@/components/qualite/SidebarQualite.vue";
import ExportQualite from "@/components/qualite/ExportQualite.vue";
import i18n from "../plugins/vue-i18n";
import {namespace} from "vuex-class";
import IQualite from '@/types/qualite.interface';
import qualiteService from '@/services/qualite.service';
import panierService from "@/services/panier.service";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule");

@Component({
    components: {
        FilesQualite,
        SidebarQualite,
        ExportQualite
    },
})
export default class Qualite extends Vue {
    modify: boolean;
    tab = null;
    stepper = 1;
    items = [
        {tab: i18n.tc("enrichissement.tabs.files"), content: "FilesQualite", step: 1},
        {tab: i18n.tc("enrichissement.tabs.export"), content: "ExportQualite", step: 2},
    ];
    result = {
        nb: 0,
        credits: 0,
    };

    @panierModule.Mutation
    public setItemCat!: (itemCat: string) => void;

    selectedType = "siren";
    selectedExportFormat = null;
    qualityFile = null;
    saveModal = false;
    isLoadingData = false;
    basket = null;

    created() {
        this.setItemCat("Qualite");
        this.modify = false;
        if (this.$route.params.id) {
            panierService.getFileFromId(this.$route.params.id).then((res) => {
                this.basket = res.data.message.basket.Items[0];
                this.qualite = res.data.message.basket.Items[0].filters;
                // qualite has only one file
                this.qualityFile = this.qualite.files[0];
                this.selectedType = this.qualite.type;
                this.refreshResult();
                this.modify = true;
            });
        }
    }

    uploadFormat(format) {
        this.selectedExportFormat = format;
    }

    uploadType(type) {
        this.selectedType = type;
    }

    uploadFile(file) {

        if (Array.isArray(file))
            this.qualityFile = file[0];
        else
            this.qualityFile = file;
        this.refreshResult();
    }

    setId(data) {
        this.qualityFile.id = data[0];
    }

    setUuid(data) {
        this.qualityFile.uuid = data[0];
    }

    @userModule.State
    public user!: any;

    @panierModule.Action
    public addProduct!: () => void;

    public qualite: IQualite = {
        type: this.selectedType,
        files: []
    };

    refreshResult() {
        this.updateQualite();
        if (this.qualite.files.length > 0) {
            this.isLoadingData = true;
            qualiteService
                .getPrice(this.qualite)
                .then((res) => {
                    this.result.credits = res.data.message.credits;
                    this.isLoadingData = false;
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            this.result.credits = 0;
        }
    }

    order() {
        this.updateQualite();

        const id = Date.now();
        const product = {
            id: id,
            type: "qualite",
            segment: this.selectedType == "siret",
            date: new Date().toLocaleDateString(),
            results: this.qualite.files[0].lines,
            credits: this.result.credits,
            format: "csv",
            content: JSON.parse(JSON.stringify({...this.qualite, ...{productId: id}}))
        };
        if (this.modify) {
            panierService.putBasket(this.basket.basketId, null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, this.basket.basketStatus, this.user.email, product.content).then(res => {
                this.saveModal = true;
                this.isLoadingData = false;
            });
        } else {
            panierService.postFile(null, product.results, product.credits, product.format, product.segment, product.type, this.user.id, product.content).then(res => {
                this.addProduct();
                this.saveModal = true;
                this.isLoadingData = false;
            });
        }
    }

    updateQualite() {
        this.qualite.type = this.selectedType;
        this.qualite.email = this.user.email;
        if (this.qualityFile) {
            this.qualite.files.push(this.qualityFile);
        } else {
            this.qualite.files = [];
        }
    }

    previewData() {
        this.updateQualite();
        qualiteService.preview(this.qualite, this.user).then((res) => {
            this.$router.push({path: '/', query: {audit: 'true'}});
        });
    }
}
